// import { useDividas } from "../../../../../context/DividasContext";
import { useDividas } from "../../../../../context/DividasContext";
import { useFila } from "../../../../../context/FilaContext";
import { formatCPFCNPJ } from "../../../../../utils/formatCPFCNPJ";

export const ClienteInfo = () => {
  const { devedorCadastro } = useDividas()
  // const { devedorFilaSelected } = useFila()
  return (
    <div className="my-4 flex w-full items-center gap-8 ">
      <p>
        <strong className="font-medium text-gray-800">Nome: </strong> {devedorCadastro?.nomclien && devedorCadastro?.nomclien.toUpperCase()}
      </p>
      <p>
        <strong className="font-medium text-gray-800">CPF/CNPJ: </strong>
        {devedorCadastro?.cpfcnpj && formatCPFCNPJ(devedorCadastro?.cpfcnpj)}
      </p>
    </div>
  );
};
